// jQuery is injected via jquery-shim.js (see esbuild.config.mjs)

// Bootstrap 3 (requires jQuery global)
import 'bootstrap/dist/js/bootstrap.js';

// Owl Carousel
import 'owl.carousel';

// Cookie Consent (vanilla-cookieconsent by orestbida)
import './cookieconsent-init.js';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

// Site-specific scripts
jQuery(function($) {
    // Swipebox initialization
    if ($.fn.swipebox) {
        $('.swipebox').swipebox({
            hideBarsDelay: 0
        });
    }

    // Sticky navbar
    const navbar = document.querySelector('.navbar-sticky');
    if (navbar) {
        let top = navbar.offsetTop;

        function stickynavbar() {
            if (window.scrollY >= top) {
                navbar.classList.add('navbar-sticky-fixed');
            } else {
                navbar.classList.remove('navbar-sticky-fixed');
            }
        }
        window.addEventListener('scroll', stickynavbar);
    }

    // Calendar popup toggle
    $('.akce_nadpis').click(function() {
        var kal = $(this).data('kalendar');
        $('.kal-pop-' + kal).slideToggle();
        $('.kal-pop-btn-' + kal).toggle();
    });
});


Fancybox.bind("[data-fancybox]", {
    // Your custom options

});